import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Fire a Facebook Pixel standard or custom event.
 * Safe to call even if the pixel hasn't loaded (e.g. on subdomains).
 */
export function trackPixelEvent(
  eventName: string,
  params?: Record<string, string | number | boolean>
) {
  if (typeof window.fbq === 'function') {
    if (params) {
      window.fbq('track', eventName, params);
    } else {
      window.fbq('track', eventName);
    }
  }
}

/**
 * Renderless component that fires a PageView event on every SPA route change.
 * The initial PageView is handled by the base snippet in index.html,
 * so the first pathname is skipped.
 */
export function FacebookPixelTracker() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    trackPixelEvent('PageView');
  }, [location.pathname]);

  return null;
}
